/**
 * Encapsulated Interface methods for each chart.
 * The chart instance is private.
 *
 * We do this so we don't have to consume the Highcharts API directly
 * because it doesn't play nicely with React.
 *
 * @type {Object}
 */
const makeChartApi = Highcharts => {

  let _instance;

  const create = (config, el) => {
    if (!config.chart) {
      config.chart = {};
    }
    config.chart.renderTo = el;
    _instance = new Highcharts.chart(config);
    return _instance;
  };

  /**
   * Update a chart
   * Disclaimer: for "update" we think that rehydrating makes best sense
   * here, rather than using Highcharts' update methods such as
   * Highcharts.update. Instances are destroyed then recreated. We do this
   * because Highcharts appends state to DOM which breaks the expectations
   * of how React works and means that it's possible for the chart to get
   * out of sync with your application.
   * @param nextConfig
   * @param el
   */
  const update = (nextConfig, el) => { // redraw
    destroy();
    return create(nextConfig, el);
  };

  const destroy = () => {
    if (_instance) {
      _instance.destroy();
      _instance = null;
    }
    return _instance;
  };

  return {
    create,
    update,
    destroy,
    // return Highcharts for primitive access, but consumers should avoid
    // using it and use the service methods instead
    Highcharts,
  }
};

export default makeChartApi;
